import React, { useMemo } from 'react';
import { Props } from '../InlineView';
import DeviationMediaService from '../../../utils/DeviationMediaService';

const ImageInlineView: React.FC<Props> = ({
  deviation,
  width: propWidth,
  height: propHeight,
  crop = 'fill',
}: Props) => {
  const thumb = useMemo(() => {
    return DeviationMediaService.getSmallestThumbThatFullyCovers(
      deviation,
      propWidth,
      propHeight ?? Infinity,
      t => t[t.length - 1], // Take largest if nothing covers,
      {
        thumbTypes: ['375W', '414W', '750W', '828W'],
      }
    );
  }, [deviation, propHeight, propWidth]);

  if (!thumb) {
    return <span>Failed to render</span>;
  }

  return (
    <img
      loading="lazy"
      src={thumb.src}
      alt={deviation.title}
      width={Math.min(thumb.width ?? Infinity, propWidth)}
      height={Math.min(thumb.height ?? Infinity, propHeight!)}
      style={{ objectFit: crop, verticalAlign: 'bottom' }}
    />
  );
};
ImageInlineView.displayName = 'ImageInlineView';

export default ImageInlineView;
